import { render, staticRenderFns } from "./myDashboard.vue?vue&type=template&id=9a0e8808"
import script from "./myDashboard.vue?vue&type=script&lang=js"
export * from "./myDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports